import React, { createContext, useState } from "react";
import { useLocalStorage } from "../helper/useLocalStorage";

const StateContext = createContext();

const StateContextProvider = ({ children }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [showOrderHistory, setShowOrderHistory] = useState(false);
  const [cart, setCart] = useLocalStorage("pizza-cart", {
    items: [],
    delivery: 5,
  });
  const [user, setUser] = useLocalStorage("pizza-user", null);
  const [ingredients, setIngredients] = useState(null);

  const state = {
    cart,
    setCart,
    user,
    setUser,
    ingredients,
    setIngredients,
    showLoginModal,
    setShowLoginModal,
    showOrder,
    setShowOrder,
    showOrderHistory,
    setShowOrderHistory,
  };

  return (
    <StateContext.Provider value={state}>{children}</StateContext.Provider>
  );
};

export { StateContext, StateContextProvider };
